import React from 'react'
import { FormikProps, getIn } from 'formik'
import { CheckBox } from '../Input/CheckBox'
import { ErrorLabel } from '..'
import { useT } from '_metronic/i18n/Metronici18n'

interface FormCheckBoxProps {
  formik: FormikProps<any>
  name: string
  label?: string
  /** Prefixo do id do input; padrão é o `name`. Use quando o mesmo campo aparece em mais de um formulário na tela. */
  id?: string
  className?: string
  isDisabled?: boolean
  entity?: string
  /** Chamado depois de gravar o valor no formik, para efeitos colaterais (ex.: limpar um campo dependente). */
  onChange?: (checked: boolean) => void
}

export const FormCheckBox: React.FC<FormCheckBoxProps> = ({
  formik,
  name,
  label,
  id,
  className = '',
  isDisabled = false,
  entity,
  onChange,
}) => {
  const { t } = useT()

  const errorMessage = getIn(formik.errors, name, null)
  const touched = getIn(formik.touched, name, false)
  const value = getIn(formik.values, name, false)

  const resolvedLabel = label ?? (entity ? t(`${entity}.label`) : undefined)

  return (
    <div className={className}>
      <CheckBox
        id={id ?? name}
        label={resolvedLabel}
        checked={value === true}
        disabled={formik.isSubmitting || isDisabled}
        touched={touched}
        error={errorMessage}
        onChange={(evento) => {
          formik.setFieldValue(name, evento.target.checked)
          onChange?.(evento.target.checked)
        }}
        onBlur={() => formik.setFieldTouched(name, true)}
      />
      {touched && errorMessage && <ErrorLabel>{errorMessage}</ErrorLabel>}
    </div>
  )
}
